import { findProvidedServiceByServiceId } from '@repo/api-adapters/services/services.api.utils';
import type { OrderAsset } from '@repo/types/order';
import { type ModifyProvidedServiceTimeWindowCommand, OrderUpdateCommandType } from '@repo/types/order-update';
import type { TimeWindowResponseItem } from '@repo/types/time-windows';
import { invariant } from '@repo/utils/type.utils';

interface BuildModifyProvidedServiceTimeWindowCommandParams {
    orderData: OrderAsset;
    serviceId: string;
    timeWindow: TimeWindowResponseItem;
    reasonCode: string;
}

/**
 * Builds a provided-service time-window command from the selected window and matching service.
 */
export const buildModifyProvidedServiceTimeWindowCommand = ({
    orderData,
    serviceId,
    timeWindow,
    reasonCode,
}: BuildModifyProvidedServiceTimeWindowCommandParams): ModifyProvidedServiceTimeWindowCommand => {
    const matchedService = findProvidedServiceByServiceId(orderData, serviceId);
    const serviceNo = matchedService?.lineId;

    invariant(serviceNo !== undefined, `Provided service not found for serviceId: ${serviceId}`);

    return {
        type: OrderUpdateCommandType.ModifyProvidedServiceTimeWindow,
        id: crypto.randomUUID(),
        serviceNo,
        serviceTimeWindows: [
            {
                serviceDateTimeFrom: timeWindow.fromDateTimeUtc,
                serviceDateTimeTo: timeWindow.toDateTimeUtc,
                timeWindowId: timeWindow.timeWindowId,
                timeZoneId: timeWindow.timeZone,
                capacityAllocated: timeWindow.capacityAllocated ?? 1,
                reasonCode,
            },
        ],
    };
};
